import {EventUserEntity} from "../manager/NormalGameManager";

/**
 * 健康 事件 定义
 * @constructor
 */
export default function HealthEventConfig() : EventUserEntity[] {
    //数据  数组定义
    const dataArrayDefine : EventUserEntity[] = [
        // {
        //     id : 1,
        //     startValue:60,
        //     endValue:80,
        //     weight: 100,
        //     desc:"健康有点糟糕，突然生病了，花钱看病损失100元",
        //     effectParams : { key:0 ,value : -100 }
        // },
        // {
        //     id : 2,
        //     startValue:40,
        //     endValue:60,
        //     weight: 100,
        //     desc:"健康突发情况，触发多种并发症，健康值直接掉为0，需要大保健强行续命",
        //     effectParams : { key:2 ,value : -100 }
        // },
        // {
        //     id : 3,
        //     startValue:0,
        //     endValue:40,
        //     weight: 100,
        //     desc:"健康很差，突发性心机梗塞，没来得及抢救，直接原地去世",
        //     effectParams : { key:4 ,value : 1 }
        // },
    ];

    return dataArrayDefine;
}
/**
 * 获取可用的事件
 * @param currMoodValue 当前心情值
 * @param filterIdArray 过滤的id集合
 */
export function getCanHealthEventList( currMoodValue : number ,filterIdArray : number[] ){
    return HealthEventConfig().filter( ( item , index, dataList )=>{
        return item.startValue < currMoodValue && item.endValue > currMoodValue && !filterIdArray.includes( item.id );
    });
}